import * as types from '../constants/documentdetails'

const initialState = {
  Status: null,
  apiGetResult: null,
  apiPostResult: null,
  documentdetails: null,
  documentdetailsList: null,
  documentuserList: null
}

export function documentDetails(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_DOCUMENT_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_DOCUMENT_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        documentdetails: action.data
      };
    case types.FETCH_DOCUMENT_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false,
        // documentdetailsList:action.error
      };
    case types.FETCH_DOCUMENT_RESET:
      return {
        ...state,
        Status: null,
        apiGetResult: null,
        documentdetailsList: null,
        documentdetails: null,
      };
    case types.FETCH_DOCUMENT_LIST_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_DOCUMENT_LIST_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        documentdetailsList: action.data
      };
    case types.FETCH_DOCUMENT_LIST_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false
      };
      case types.FETCH_DOCUMENT_USER_LIST_REQUEST:
        return {
          ...state,
          Status: true
        };
      case types.FETCH_DOCUMENT_USER_LIST_REQUEST_COMPLETED:
        return {
          ...state,
          Status: false,
          apiGetResult: true,
          documentuserList: action.data
        };
      case types.FETCH_DOCUMENT_USER_LIST_REQUEST_ERROR:
        return {
          ...state,
          Status: false,
          apiGetResult: false,
          // documentdetailsList:action.error
        };
    case types.ADD_DOCUMENT_RESET:
      return {
        ...initialState,
        Status: null,
        apiPostResult: null
      };
    case types.ADD_DOCUMENT_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.ADD_DOCUMENT_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiPostResult: true
      };
    case types.ADD_DOCUMENT_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiPostResult: false
      };
      case types.ADD_DOCUMENT_RESET:
        return {
          ...initialState,
          Status: null,
          apiPostResult: null
        };
      case types.UPDATE_FILE_REQUEST:
        return {
          ...initialState,
          Status: true
        };
      case types.UPDATE_FILE_REQUEST_COMPLETED:
        return {
          ...state,
          Status: false,
          apiPostResult: true
        };
      case types.UPDATE_FILE_REQUEST_ERROR:
        return {
          ...state,
          Status: false,
          apiPostResult: false
        };
    default:
      return state;
  }
} 


// WEBPACK FOOTER //
// ./reducers/documentdetails.js